/* PES Collection UI v6 — Sidebar Fix + Enhanced Filters */
(function(){'use strict';

/* ========== SORT DROPDOWN ========== */
var sortLabels={
'best-selling':'Best Selling',
'price-ascending':'Price: Low to High',
'price-descending':'Price: High to Low',
'title-ascending':'Name: A to Z',
'title-descending':'Name: Z to A',
'created-ascending':'Date: Old to New',
'created-descending':'Date: New to Old',
'manual':'Featured'
};

function initSortDropdown(){
var existing=document.getElementById('pes-sort-select');
if(existing)return;
var toolbar=document.querySelector('.facets-vertical-sort, .collection-toolbar, .product-grid-container, .custm-mn-topslder');
if(!toolbar)return;
var sortWrap=document.createElement('div');
sortWrap.className='pes-sort-wrap';
sortWrap.style.cssText='display:flex;align-items:center;gap:8px;margin:0 0 0 auto;';
var label=document.createElement('span');
label.className='pes-sort-label';
label.textContent='Sort:';
label.style.cssText='font-size:13px;color:#666;font-weight:500;';
var select=document.createElement('select');
select.id='pes-sort-select';
select.className='pes-sort-select';
select.style.cssText='padding:6px 28px 6px 12px;border:1px solid #ddd;border-radius:6px;font-size:14px;background:#fff;color:#333;cursor:pointer;';
var currentSort=new URLSearchParams(window.location.search).get('sort_by')||'best-selling';
Object.keys(sortLabels).forEach(function(key){
var opt=document.createElement('option');
opt.value=key;
opt.textContent=sortLabels[key];
if(key===currentSort)opt.selected=true;
select.appendChild(opt);
});
select.addEventListener('change',function(){
var url=new URL(window.location.href);
url.searchParams.set('sort_by',select.value);
window.location.href=url.toString();
});
sortWrap.appendChild(label);
sortWrap.appendChild(select);
var targetEl=toolbar.querySelector('.facets-vertical-sort, .facet-filters__sort');
if(targetEl){targetEl.appendChild(sortWrap);}
else{toolbar.insertBefore(sortWrap,toolbar.firstChild);}
}

/* ========== CSS INJECTION ========== */
var css=`
/* === LAYOUT FIX: Show sidebar as left column === */
.cust-desktop-sortfilter{
  display:block!important;
  width:260px!important;
  min-width:260px!important;
  flex-shrink:0!important;
  position:sticky!important;
  top:80px!important;
  max-height:calc(100vh - 100px)!important;
  overflow-y:auto!important;
  padding-right:8px;
}
.cstm-collect-facets-container.facets-vertical{
  display:flex!important;
  gap:24px!important;
  align-items:flex-start!important;
}
.collection_main_grid{
  flex:1!important;
  min-width:0!important;
}
/* Hide native sort (we have our own) */
.facet-filters.sorting,
.cust-desktop-sortfilter .facet-filters__sort,
.cust-desktop-sortfilter .select,
#SortBy,
#FacetSortForm{
  display:none!important;
}
/* Hide native facet checkboxes */
.facet-checkbox{display:none!important}

/* === SIDEBAR STYLING === */
.pes-sidebar{
  background:#fff;
  border:1px solid #e5e5e5;
  border-radius:8px;
  padding:0 16px 16px;
}
.pes-sidebar-title{
  font-size:16px;
  font-weight:700;
  color:#0f1e2d;
  margin:0;
  padding:16px 0 12px;
  border-bottom:2px solid #11B67B;
  display:flex;
  align-items:center;
  justify-content:space-between;
}
.pes-sidebar-title span{font-size:12px;color:#999;font-weight:400;}
.pes-filter-group{
  border-bottom:1px solid #eee;
  padding:12px 0;
}
.pes-filter-group:last-child{border-bottom:none;}
.pes-filter-group-header{
  font-size:13px;
  font-weight:700;
  text-transform:uppercase;
  letter-spacing:.5px;
  color:#333;
  margin:0 0 8px;
  cursor:pointer;
  display:flex;
  justify-content:space-between;
  align-items:center;
  user-select:none;
}
.pes-filter-group-header .toggle{
  width:20px;
  height:20px;
  display:flex;
  align-items:center;
  justify-content:center;
  font-size:16px;
  color:#999;
  transition:transform .2s;
}
.pes-filter-group.collapsed .toggle{transform:rotate(-90deg);}
.pes-filter-group.collapsed .pes-filter-list{display:none;}
.pes-filter-list{
  list-style:none;
  padding:0;
  margin:0;
}
.pes-filter-list li{margin-bottom:2px;}
.pes-filter-list a{
  font-size:13px;
  color:#555;
  text-decoration:none;
  padding:6px 8px;
  display:block;
  border-radius:4px;
  transition:all .15s;
  position:relative;
}
.pes-filter-list a:hover{
  background:#f5f5f5;
  color:#11B67B;
}
.pes-filter-list a.active{
  background:#e8f7f0;
  color:#11B67B;
  font-weight:600;
}
.pes-filter-list a .count{
  font-size:11px;
  color:#999;
  margin-left:4px;
}

/* === ACTIVE FILTER CHIPS === */
.pes-active-filters{
  display:flex;
  flex-wrap:wrap;
  gap:6px;
  margin-bottom:12px;
  padding-top:8px;
}
.pes-filter-chip{
  background:#11B67B;
  color:#fff;
  padding:4px 10px;
  border-radius:12px;
  font-size:12px;
  font-weight:500;
  display:inline-flex;
  align-items:center;
  gap:4px;
  cursor:pointer;
  text-decoration:none;
  border:none;
}
.pes-filter-chip:hover{background:#0d9460;}
.pes-filter-chip .x{font-size:14px;margin-left:2px;font-weight:700;}
.pes-clear-all{
  font-size:12px;
  color:#999;
  text-decoration:underline;
  cursor:pointer;
  background:none;
  border:none;
  padding:4px 8px;
}

/* === PRICE SLIDER === */
.pes-price-inputs{
  display:flex;
  align-items:center;
  gap:8px;
  margin-top:8px;
}
.pes-price-inputs input{
  width:80px;
  padding:6px 8px;
  border:1px solid #ddd;
  border-radius:4px;
  font-size:13px;
}
.pes-price-inputs .sep{color:#999;font-size:13px;}
.pes-price-go{
  padding:6px 12px;
  background:#11B67B;
  color:#fff;
  border:none;
  border-radius:4px;
  font-size:13px;
  cursor:pointer;
  font-weight:600;
}
.pes-price-go:hover{background:#0d9460;}

/* === BROWSE BUBBLE HIDE === */
.pes-browse-bubble,.browse-collection-bubble,[class*="browse"][class*="bubble"],
.browse-all-categories,[class*="Browse this collection"]{display:none!important}
a[href*="browse"][class*="bubble"]{display:none!important}
.custm-mn-topslder .mblfitlers a[href*="browse"]{display:none!important}

/* === MOBILE (defer entirely to pes-collection-filters.js drawer, breakpoint 989px) === */
@media(max-width:989px){
  .cust-desktop-sortfilter{
    display:none!important;
  }
}
`;

function injectCSS(){
var style=document.createElement('style');
style.textContent=css;
document.head.appendChild(style);
}

/* ========== ENHANCED FILTER SIDEBAR ========== */
function buildSidebar(){
var container=document.querySelector('.facets-container')||document.querySelector('.cust-desktop-sortfilter');
if(!container)return;
// Remove old fallback filters
var old=container.querySelector('.pes-fallback-filters, .pes-sidebar');
if(old)old.remove();

var m=window.location.pathname.match(/\/collections\/([^\/\?]+)/);
if(!m)return;
var handle=m[1];

// Get current URL params for active filter detection
var params=new URLSearchParams(window.location.search);
var activeVendor=params.get('filter.p.vendor');
var activePriceGte=params.get('filter.v.price.gte');
var activePriceLte=params.get('filter.v.price.lte');

// Dynamic per-collection filter config (2026-08-04 rework)
// Replaces the hardcoded 7-collection map: vendors + product types are
// computed live from the collection's own products, so every one of the
// 300+ collections gets accurate Brand/Type groups automatically.
var priceMap={
'solar-panels':[['Under $150',null,'150'],['$150 – $250','150','250'],['$250 – $350','250','350'],['$350 – $500','350','500'],['$500+','500',null]],
'inverters':[['Under $500',null,'500'],['$500 – $1,000','500','1000'],['$1,000 – $2,000','1000','2000'],['$2,000 – $5,000','2000','5000'],['$5,000+','5000',null]],
'batteries-energy-storage':[['Under $1,000',null,'1000'],['$1,000 – $3,000','1000','3000'],['$3,000 – $5,000','3000','5000'],['$5,000 – $10,000','5000','10000'],['$10,000+','10000',null]],
'charge-controllers':[['Under $100',null,'100'],['$100 – $300','100','300'],['$300 – $500','300','500'],['$500+','500',null]],
'racking-mounting':[['Under $50',null,'50'],['$50 – $150','50','150'],['$150 – $500','150','500'],['$500+','500',null]],
'electrical-supplies':[['Under $25',null,'25'],['$25 – $100','25','100'],['$100 – $500','100','500'],['$500+','500',null]],
'commercial-standby-generators':[['Under $2,000',null,'2000'],['$2,000 – $5,000','2000','5000'],['$5,000 – $10,000','5000','10000'],['$10,000+','10000',null]],
'generators':[['Under $2,000',null,'2000'],['$2,000 – $5,000','2000','5000'],['$5,000 – $10,000','5000','10000'],['$10,000+','10000',null]],
'ev-chargers':[['Under $300',null,'300'],['$300 – $600','300','600'],['$600 – $1,000','600','1000'],['$1,000+','1000',null]]
};
var defaultPrices=[['Under $250',null,'250'],['$250 – $500','250','500'],['$500 – $1,000','500','1000'],['$1,000+','1000',null]];

function priceBuckets(h){
var rows=priceMap[h]||defaultPrices;
return rows.map(function(r){return {label:r[0],gte:r[1],lte:r[2]};});
}

function baseGroups(h){
return [
{name:'Price Range',type:'price',values:priceBuckets(h)},
{name:'Availability',type:'availability',values:[{label:'In Stock Only',param:'filter.v.availability',value:'1'}]}
];
}

var sidebarInflight=false;
function withConfig(h,cb){
if(sidebarInflight)return;
sidebarInflight=true;
var cacheKey='pes-fc-'+h;
try{
var cached=sessionStorage.getItem(cacheKey);
if(cached){sidebarInflight=false;cb(JSON.parse(cached));return;}
}catch(e){}
fetch('/collections/'+h+'/products.json?limit=250')
.then(function(r){return r.ok?r.json():{products:[]};})
.then(function(d){
sidebarInflight=false;
var prods=d.products||[];
var vendorCounts={},typeCounts={};
prods.forEach(function(p){
if(p.vendor)vendorCounts[p.vendor]=(vendorCounts[p.vendor]||0)+1;
if(p.product_type)typeCounts[p.product_type]=(typeCounts[p.product_type]||0)+1;
});
var groups=[];
var types=Object.keys(typeCounts).sort(function(a,b){return typeCounts[b]-typeCounts[a];}).slice(0,10);
if(types.length>1)groups.push({name:'Type',type:'product_type',values:types});
var vendors=Object.keys(vendorCounts).sort(function(a,b){return vendorCounts[b]-vendorCounts[a];}).slice(0,12);
if(vendors.length)groups.push({name:'Brand',type:'vendor',values:vendors});
groups=groups.concat(baseGroups(h));
var config={groups:groups};
try{sessionStorage.setItem(cacheKey,JSON.stringify(config));}catch(e){}
cb(config);
})
.catch(function(){
sidebarInflight=false;
cb({groups:baseGroups(h)});
});
}

withConfig(handle,function(config){
if(!config)return;
// Build sidebar HTML
var html='<div class="pes-sidebar">';
html+='<h3 class="pes-sidebar-title">Filters <span>Refine</span></h3>';

// Active filter chips
var hasActive=activeVendor||activePriceGte||activePriceLte||params.get('filter.v.availability')||params.get('filter.p.product_type');
if(hasActive){
html+='<div class="pes-active-filters">';
if(activeVendor){
html+='<a class="pes-filter-chip" href="'+clearParam('filter.p.vendor')+'">'+activeVendor+' <span class="x">×</span></a>';
}
if(activePriceGte||activePriceLte){
var plabel='';
if(activePriceGte&&activePriceLte)plabel='$'+activePriceGte+'–$'+activePriceLte;
else if(activePriceGte)plabel='$'+activePriceGte+'+';
else plabel='Under $'+activePriceLte;
html+='<a class="pes-filter-chip" href="'+clearParams(['filter.v.price.gte','filter.v.price.lte'])+'">'+plabel+' <span class="x">×</span></a>';
}
if(params.get('filter.p.product_type')){
html+='<a class="pes-filter-chip" href="'+clearParam('filter.p.product_type')+'">'+params.get('filter.p.product_type')+' <span class="x">×</span></a>';
}
if(params.get('filter.v.availability')){
html+='<a class="pes-filter-chip" href="'+clearParam('filter.v.availability')+'">In Stock <span class="x">×</span></a>';
}
html+='<a class="pes-clear-all" href="/collections/'+handle+'">Clear All</a>';
html+='</div>';
}

// Filter groups
config.groups.forEach(function(group,gi){
html+='<div class="pes-filter-group'+(gi>2?' collapsed':'')+'" data-group="'+gi+'">';
html+='<div class="pes-filter-group-header">'+group.name+'<span class="toggle">▾</span></div>';
html+='<ul class="pes-filter-list">';

if(group.type==='vendor'){
group.values.forEach(function(vendor){
var u='/collections/'+handle+'?filter.p.vendor='+encodeURIComponent(vendor);
var isActive=activeVendor===vendor;
html+='<li><a href="'+u+'"'+(isActive?' class="active"':'')+'>'+vendor+'</a></li>';
});
}else if(group.type==='price'){
group.values.forEach(function(pv){
var params2=new URLSearchParams();
if(pv.gte)params2.set('filter.v.price.gte',pv.gte);
if(pv.lte)params2.set('filter.v.price.lte',pv.lte);
var u='/collections/'+handle+'?'+params2.toString();
html+='<li><a href="'+u+'">'+pv.label+'</a></li>';
});
// Price input fields
html+='<li><div class="pes-price-inputs">';
html+='<input type="number" id="pes-price-min" placeholder="$ Min" value="'+(activePriceGte||'')+'">';
html+='<span class="sep">–</span>';
html+='<input type="number" id="pes-price-max" placeholder="$ Max" value="'+(activePriceLte||'')+'">';
html+='<button class="pes-price-go" onclick="var u=new URL(window.location.href);var mn=document.getElementById(\'pes-price-min\').value;var mx=document.getElementById(\'pes-price-max\').value;if(mn)u.searchParams.set(\'filter.v.price.gte\',mn);else u.searchParams.delete(\'filter.v.price.gte\');if(mx)u.searchParams.set(\'filter.v.price.lte\',mx);else u.searchParams.delete(\'filter.v.price.lte\');window.location.href=u.toString();">Go</button>';
html+='</div></li>';
}else if(group.type==='availability'){
group.values.forEach(function(av){
var u='/collections/'+handle+'?'+av.param+'='+av.value;
var isActive=params.get(av.param)===av.value;
html+='<li><a href="'+u+'"'+(isActive?' class="active"':'')+'>'+av.label+'</a></li>';
});
}else if(group.type==='product_type'){
var activeType=params.get('filter.p.product_type');
group.values.forEach(function(t){
var u='/collections/'+handle+'?filter.p.product_type='+encodeURIComponent(t);
var isActive=activeType===t;
html+='<li><a href="'+u+'"'+(isActive?' class="active"':'')+'>'+t+'</a></li>';
});
}else if(group.type==='tag'){
group.values.forEach(function(tv){
var u='/collections/'+handle+'/'+tv.tag;
html+='<li><a href="'+u+'">'+tv.label+'</a></li>';
});
}

html+='</ul>';
html+='</div>';
});

html+='</div>';

// Inject into container
container.innerHTML=html;
container.style.minHeight='auto';
container.style.padding='0';

// Add accordion toggle
container.querySelectorAll('.pes-filter-group-header').forEach(function(header){
header.addEventListener('click',function(){
var group=header.parentElement;
group.classList.toggle('collapsed');
});
});
// Mobile filter button and drawer are owned by pes-collection-filters.js (clones this container's content at <=989px).
});}

function clearParam(paramName){
var u=new URL(window.location.href);
u.searchParams.delete(paramName);
return u.toString();
}
function clearParams(paramNames){
var u=new URL(window.location.href);
paramNames.forEach(function(p){u.searchParams.delete(p);});
return u.toString();
}

/* ========== SUBNAV ACTIVE STATE ========== */
function fixSubnav(){
var items=document.querySelectorAll('.collection-subnavigation__item, .pes-subnav-item');
if(!items.length)return;
var path=window.location.pathname.toLowerCase();
items.forEach(function(item){
var link=item.querySelector('a');
if(link){
var href=link.getAttribute('href');
if(href&&path.indexOf(href.toLowerCase())>=0){item.classList.add('active');}
else{item.classList.remove('active');}
}
});
}

/* ========== BROWSE BUBBLE ========== */
function removeBrowseBubble(){
var b=document.querySelectorAll('[class*="browse-bubble"]');
b.forEach(function(e){e.style.display='none';});
}

/* ========== FORCE SIDEBAR VISIBLE (desktop only) ========== */
function forceSidebarVisible(){
if(window.innerWidth<=989){
// Mobile/tablet: never force the desktop sidebar open. Let the drawer CSS/JS (pes-collection-filters.js, breakpoint 989px) own visibility.
return;
}
var sf=document.querySelector('.cust-desktop-sortfilter');
if(sf){
sf.style.setProperty('display','block','important');
sf.style.setProperty('width','260px','important');
sf.style.setProperty('min-width','260px','important');
sf.style.setProperty('flex-shrink','0','important');
sf.style.setProperty('position','sticky','important');
sf.style.setProperty('top','80px','important');
sf.style.setProperty('max-height','calc(100vh - 100px)','important');
sf.style.setProperty('overflow-y','auto','important');
sf.style.setProperty('visibility','visible','important');
sf.style.setProperty('opacity','1','important');
}
var fc=document.querySelector('.cstm-collect-facets-container');
if(fc){
fc.style.setProperty('display','flex','important');
fc.style.setProperty('gap','24px','important');
fc.style.setProperty('align-items','flex-start','important');
}
var grid=document.querySelector('.collection_main_grid');
if(grid){
grid.style.setProperty('flex','1','important');
grid.style.setProperty('min-width','0','important');
}
}

/* ========== INIT ========== */
function init(){
injectCSS();
forceSidebarVisible();
initSortDropdown();
fixSubnav();
removeBrowseBubble();
buildSidebar();
forceSidebarVisible();
}

if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}
else{init();}
setTimeout(function(){init();},500);
setTimeout(function(){init();},2000);
setTimeout(function(){init();},4000);
document.addEventListener('shopify:section:load',init);

// MutationObserver to keep sidebar visible if other scripts hide it
if(typeof MutationObserver!=='undefined'){
var mo=new MutationObserver(function(){forceSidebarVisible();});
if(document.body)mo.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['style','class']});
}
})();
